
// src/features/auth/authSlice.ts

import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AccountInfo } from '@azure/msal-browser';

// 1. Define a new, simple interface for the data we WANT to store.
interface SimpleAccountInfo {
  homeAccountId: string;
  name?: string;
  username: string;
}

interface AuthState {
  isAuthenticated: boolean;
  account: SimpleAccountInfo | null;
  role: string | null;
  roleKey: string | null;
}

const initialState: AuthState = {
  isAuthenticated: false,
  account: null,
  role: null,
  roleKey: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuthState: (state, action: PayloadAction<{ isAuthenticated: boolean; account: AccountInfo | null }>) => {
      state.isAuthenticated = action.payload.isAuthenticated;

      if (action.payload.account) {
        // 2. Instead of saving the whole complex object, we create a new, simple one.
        // We only take the serializable properties we need.
        state.account = {
          homeAccountId: action.payload.account.homeAccountId,
          name: action.payload.account.name,
          username: action.payload.account.username,
        };
      } else {
        state.account = null;
      }
    },

    setUserRole: (state, action: PayloadAction<string>) => {
      state.role = action.payload;
  state.roleKey = action.payload;
},
    logout: (state) => {
      state.isAuthenticated = false;
      state.account = null;
      state.roleKey = null;
    },
  },
});

export const { setAuthState, setUserRole, logout } = authSlice.actions;
export default authSlice.reducer;